import React, { useRef, useEffect } from 'react';

const MAX_HEIGHT = 140; // ~5 lignes avant de scroller

/**
 * Champ de saisie multi-lignes pour les conversations.
 * Ordinateur : Entrée envoie, Maj+Entrée saute une ligne.
 * Mobile/tactile : Entrée saute une ligne, l'envoi se fait au bouton.
 */
export const ChatTextarea = ({
  value,
  onChange,
  onSubmit,
  placeholder,
  disabled = false,
  className = '',
  testId,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, MAX_HEIGHT)}px`;
  }, [value]);

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter' || e.shiftKey) return;
    const isTouch = window.matchMedia?.('(pointer: coarse)').matches;
    if (isTouch) return; // mobile : Entrée = retour à la ligne
    e.preventDefault();
    onSubmit?.();
  };

  return (
    <textarea
      ref={ref}
      rows={1}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
      placeholder={placeholder}
      disabled={disabled}
      enterKeyHint="enter"
      inputMode="text"
      className={`w-full resize-none overflow-y-auto rounded-md border border-border bg-secondary/50 px-3 py-2.5 text-sm leading-relaxed placeholder:text-muted-foreground focus:border-primary focus-visible:outline-none disabled:opacity-50 ${className}`}
      data-testid={testId}
    />
  );
};

export default ChatTextarea;
